import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Close from "../../../assets/images/close-icon.png";
import { debounce } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import ProfilePic from "../../../assets/images/dummy_profile.png";
import Loader from "../../../components/Loader/Loader";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useDispatch } from "react-redux";
import { usePermissions } from "../../../context/permissionContext";
import { ADMIN_LOGOUT } from "../../../redux/constants/adminConstants";
import { validatePermission } from "../../../utils/permissionUtils";
import { CircularProgressbar } from "react-circular-progressbar";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import "react-circular-progressbar/dist/styles.css";
import "../../../components/common/css/datatable.scss";
import PageShell from "../../../components/layout/PageShell";
import PageHead from "../../../components/layout/PageHead";
import useResponsiveColumns from "../../../hooks/useResponsiveColumns";
import { useRole } from "../../../hooks/useRole";
import { roleLabel } from "../../../utils/roleLabels";
import RoleChips, { roleRowHeight } from "./RoleChips";
import AdTransferDialog from "./AdTransferDialog";

// AD is a singleton and the only legal way to move it is a transfer, so
// every refusal that mentions it has to point at the control that does it.
const AD_TRANSFER_HINT = "Use Transfer on the Platform Manager chip.";

// Responsive column visibility: hide lower-value columns as the viewport
// narrows. Module-level so the object reference is stable across renders.
const USER_COL_PRIORITY = {
  id: "low",
  Comp_KYC_status: "low",
  KYC_status: "medium",
  userType: "medium",
};

const Userlist = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [percentage, setPercentage] = useState([]);
  const [loading, setLoading] = useState(false);
 
  const [open, setOpen] = useState(false);
  const [firstname, setFirstname] = useState();
  const [lastname, setLasttname] = useState();
  const [getEmail, setEmail] = useState();
  const [verfiecationStatus, setVerificationStatus] = useState();
  // Full canonical-role catalog from GET /admin/roles/assignable — every row
  // carries { code, display_name, assignable, requires_sponsor, legacy_role_id }.
  // The dropdown offers the assignable subset; non-assignable rows are only used
  // to label a user's current (unlistable) role.
  const [roles, setRoles] = useState([]);
  const [id, setID] = useState();
  const userData = JSON.parse(localStorage.getItem("admin"));
  const loginUserID = userData?.data?.id || null;
  const { hasRole } = useRole();
  // Role assignment is AD-only (server-enforced). Non-AD sessions see the
  // dropdown read-only rather than a broken write path.
  const isAD = hasRole("AD");

  // Sponsor-picker modal (shown when assigning CONSULTANT, which requires a
  // sponsoring BDC). Built as a simple search over the existing users list API,
  // filtered client-side to BDC-role users.
  const [sponsorModal, setSponsorModal] = useState(null); // { userId, roleId }
  const [sponsorSearch, setSponsorSearch] = useState("");
  const [sponsorResults, setSponsorResults] = useState([]);
  const [sponsorLoading, setSponsorLoading] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null);
  const [assignReason, setAssignReason] = useState("");
  // The row whose Platform Manager chip is being transferred away.
  const [adTransferFrom, setAdTransferFrom] = useState(null);
  const [pageState, setPageState] = useState({
    data: [],
    total: 0,
    page: 1,
    pageSize: 9,
  });
   const { permissions, permissionsMapping } = usePermissions();
  const handleClose = () => setOpen(false);
  const handleOpen = (row) => {
    setOpen(true);
    setID(row?.id);
    setFirstname(row?.firstname);
    setLasttname(row?.lastname);
    setEmail(row?.email);
  };

  const updateFirstName = (e) => {
    let getFirstname = e.target.value;
    setFirstname(getFirstname);
  };

  const updateLastName = (e) => {
    let getFirstname = e.target.value;
    setLasttname(getFirstname);
  };
  
  function LinearProgressWithLabel(props) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "100%", mr: 1 }}>
          <LinearProgress
            style={{ width: 200, height: 5 }}
            variant="determinate"
            color={props.value > 50 ? "primary" : "secondary"}
            {...props}
          />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }

  const handleQuery = useCallback(
    debounce((e) => {
      setQuery(e.target.value);
      setPageState({ ...pageState, page: 1 });
    }, 1000)
  );

  const fetchuserData = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    setPageState((old) => ({ ...old }));
    // Construct the payload with dynamic verification filters
    let payload = {
      page: pageState.page,
      limit: pageState.pageSize,
      searchTerm: query, // Keep search functionality
    };

    // Apply filtering based on verification status
    if (verfiecationStatus === "individual_verified") {
      payload.isVerified = true;
    } else if (verfiecationStatus === "individual_non_verified") {
      payload.isVerified = false;
    } else if (verfiecationStatus === "corporate_verified") {
      payload.comp_isVerified = true;
    } else if (verfiecationStatus === "corporate_non_verified") {
      payload.comp_isVerified = false;
    }

    axios
      .post(process.env.REACT_APP_API + "users", payload, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        setLoading(false);
        setPageState((old) => ({
          ...old,
          data: response.data.data.rows,
          total: response.data.data.count,
        }));
        setPercentage(response?.data?.data?.percent);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  useEffect(() => {
    fetchuserData();
  }, [pageState.page, pageState.pageSize, query, verfiecationStatus]);

  const fetchRoles = () => {
    const token = localStorage.getItem("accessToken");
    var config = {
      method: "get",
      url: process.env.REACT_APP_API + "admin/roles/assignable",
      headers: {
        "x-access-token": token,
      },
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        // Canonical catalog: [{ code, display_name, assignable,
        // requires_sponsor, legacy_role_id }]. Keep the full list so we can
        // label a user's current non-assignable role too.
        setRoles(Array.isArray(response?.data?.data) ? response.data.data : []);
      })
      .catch(function (error) {
        setLoading(false);
        Swal.fire({
          title: error?.response?.data?.message,
          timerProgressBar: true,
          icon: "error",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
      });
  };

  // Resolve a canonical-role catalog entry by its legacy admin_role id.
  const roleByLegacyId = (legacyId) =>
    roles.find((r) => Number(r.legacy_role_id) === Number(legacyId)) || null;

  useEffect(() => {
    fetchRoles();
  }, []);

  // `heldCodes` is what the user ALREADY holds, which decides whether this is
  // their first role or an addition to a set. The API answers ASSIGNED either
  // way, so the difference has to be known here or the copy would tell a
  // multi-role user their roles had been replaced.
  const handleAddRole = (selectedRoleId, userId, heldCodes = []) => {
    if (!selectedRoleId) return;
    const target = roleByLegacyId(selectedRoleId);
    // CONSULTANT requires a sponsoring BDC - open the sponsor picker instead of
    // POSTing straight away. The picker collects the sponsor (+ optional reason)
    // and then calls assignRole.
    if (target && (target.requires_sponsor || target.code === "CONSULTANT")) {
      setSponsorModal({ userId, roleId: selectedRoleId, heldCodes });
      setSelectedSponsor(null);
      setSponsorSearch("");
      setSponsorResults([]);
      setAssignReason("");
      return;
    }
    assignRole(userId, selectedRoleId, { heldCodes });
  };

  // POST /admin/users/:userId/roles with the canonical structured-response
  // contract. A success is always an ADD (since 2026-09-10 the server refuses
  // an incompatible role with ROLE_INCOMPATIBLE instead of swapping roles);
  // the known error codes each get a purpose-built message.
  const assignRole = (userId, roleId, { sponsorBdcUserId, reason, heldCodes } = {}) => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    const body = { roleId, updatedby: loginUserID };
    if (sponsorBdcUserId) body.sponsorBdcUserId = sponsorBdcUserId;
    if (reason && reason.trim()) body.reason = reason.trim();

    return axios
      .post(process.env.REACT_APP_API + `admin/users/${userId}/roles`, body, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data || {};
        const added = Array.isArray(heldCodes) && heldCodes.length > 0;
        Swal.fire({
          title: added ? "Role added" : "Role assigned",
          text: data.role_code
            ? `${roleLabel(data.role_code)} ${added ? "added" : "assigned"} successfully.`
            : "User role updated successfully.",
          timer: 2500,
          timerProgressBar: true,
          icon: "success",
          confirmButtonText: "OK",
          showCloseButton: true,
        });
        setSponsorModal(null);
        fetchuserData();
      })
      .catch((error) => {
        setLoading(false);
        const resp = error?.response?.data || {};
        const code = resp.code;
        let title = "Error";
        let text = resp.message || "An error occurred";

        if (code === "SPONSOR_REQUIRED") {
          title = "Sponsoring BDC required";
          text = "Assigning the Consultant role requires selecting an active sponsoring BDC.";
          // Keep / re-open the sponsor picker so the admin can supply one.
          setSponsorModal((m) => m || { userId, roleId });
        } else if (code === "AD_TRANSFER_REQUIRED") {
          title = "Platform Manager transfer required";
          text =
            `Platform Manager (AD) is a singleton role and cannot be assigned here. ${AD_TRANSFER_HINT}`;
          setSponsorModal(null);
        } else if (code === "ROLE_ALREADY_ACTIVE") {
          title = "No change";
          text = "This user already holds that role, nothing to change.";
          setSponsorModal(null);
        } else if (code === "ROLE_INCOMPATIBLE") {
          // The server names the conflict; repeating "incompatible" without it
          // leaves the admin guessing which held role is in the way. The list
          // is at the TOP level of the body: the controller spreads
          // `...error.details` into the response rather than nesting it, so
          // reading resp.details.active_roles found nothing, every time.
          const active = resp?.active_roles || resp?.details?.active_roles;
          const names = Array.isArray(active) && active.length
            ? active.map(roleLabel).join(", ")
            : "the roles this user already holds";
          title = "Roles cannot be combined";
          text = `This role cannot be combined with ${names}.`;
          setSponsorModal(null);
        } else if (code === "ROLE_NOT_ASSIGNABLE") {
          title = "Role not assignable";
          text = resp.message || "That role cannot be assigned under the canonical role model.";
          setSponsorModal(null);
        }

        Swal.fire({
          title,
          text,
          timer: code ? undefined : 2500,
          timerProgressBar: true,
          icon: code === "ROLE_ALREADY_ACTIVE" ? "info" : "error",
          confirmButtonColor: "#f27474",
          confirmButtonText: "OK",
          dangerMode: true,
          showCloseButton: true,
        });
        fetchuserData();
      });
  };

  // Sponsor picker — search the existing users list API and filter client-side
  // to BDC-role users (the API has no dedicated user-search endpoint yet).
  const searchSponsors = () => {
    const token = localStorage.getItem("accessToken");
    const bdcEntry = roles.find((r) => r.code === "BDC");
    const bdcLegacyId = bdcEntry ? bdcEntry.legacy_role_id : null;
    setSponsorLoading(true);
    axios
      .post(
        process.env.REACT_APP_API + "users",
        { page: 1, limit: 50, searchTerm: sponsorSearch },
        { headers: { "x-access-token": token } }
      )
      .then((response) => {
        setSponsorLoading(false);
        const rows = response?.data?.data?.rows || [];
        const bdcUsers =
          bdcLegacyId != null
            ? rows.filter((u) => Number(u.roleId) === Number(bdcLegacyId))
            : [];
        setSponsorResults(bdcUsers);
      })
      .catch(() => {
        setSponsorLoading(false);
        setSponsorResults([]);
      });
  };

  const confirmSponsorAssignment = () => {
    if (!sponsorModal || !selectedSponsor) return;
    assignRole(sponsorModal.userId, sponsorModal.roleId, {
      sponsorBdcUserId: selectedSponsor.id,
      reason: assignReason,
      heldCodes: sponsorModal.heldCodes,
    });
  };

  // WP2: take a role AWAY. Until now the dropdown could only move a user from
  // one role to another — there was no way to remove one, because the API had no
  // revoke/suspend endpoint mounted at all.
  //
  // The reason is collected in the confirm dialog and is MANDATORY: the server
  // refuses without it (REASON_REQUIRED), and the audit row it lands in is the
  // only durable record of why someone lost access.
  const deactivateRole = async (userId, action, roleCode) => {
    const isRevoke = action === "REVOKE";
    const verb = isRevoke ? "Revoke" : "Suspend";
    const label = roleCode ? roleLabel(roleCode) : "this user's role";

    const { value: reason, isConfirmed } = await Swal.fire({
      title: `${verb} ${label}?`,
      text: isRevoke
        ? "The user keeps their account but loses this role and any admin access it carried."
        : "The role is put on hold. The user loses access until it is restored.",
      icon: "warning",
      input: "text",
      inputLabel: "Reason (required)",
      inputPlaceholder: isRevoke ? "e.g. left the firm" : "e.g. under review",
      showCancelButton: true,
      confirmButtonText: verb,
      confirmButtonColor: isRevoke ? "#d33" : "#ed6c02",
      inputValidator: (value) =>
        !value || !value.trim() ? "A reason is required" : undefined,
    });
    if (!isConfirmed) return;

    const token = localStorage.getItem("accessToken");
    // The revoke endpoint reads role_code from the body OR the query string,
    // and says why: DELETE bodies are still dropped by some proxies. It is the
    // only DELETE we send, so it carries both.
    const base = `${process.env.REACT_APP_API}admin/users/${userId}/roles${isRevoke ? "" : "/suspend"}`;
    const url =
      isRevoke && roleCode ? `${base}?role_code=${encodeURIComponent(roleCode)}` : base;
    const headers = { "x-access-token": token };
    // role_code is what makes this a multi-role operation: without it the
    // server can only guess which of several held roles to take away.
    const body = { reason: String(reason).trim() };
    if (roleCode) body.role_code = roleCode;

    setLoading(true);
    try {
      // DELETE carries its body under `data:` — passing it positionally as with
      // .post sends it as the CONFIG object, so the reason never arrives and the
      // server answers REASON_REQUIRED for a request that plainly had one.
      const response = isRevoke
        ? await axios.delete(url, { headers, data: body })
        : await axios.post(url, body, { headers });
      const data = response?.data?.data || {};
      setLoading(false);
      Swal.fire({
        title: isRevoke ? "Role revoked" : "Role suspended",
        text: data.role_code
          ? `${roleLabel(data.role_code)} ${isRevoke ? "revoked" : "suspended"}.`
          : "The user's role was updated.",
        timer: 2500,
        timerProgressBar: true,
        icon: "success",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
      fetchuserData();
    } catch (error) {
      setLoading(false);
      const resp = error?.response?.data || {};
      let title = "Error";
      let text = resp.message || "An error occurred";
      if (resp.code === "NO_ACTIVE_ROLE") {
        title = "Nothing to change";
        text = "This user has no active role to revoke or suspend.";
      } else if (resp.code === "AD_TRANSFER_REQUIRED") {
        title = "Platform Manager transfer required";
        text =
          `Platform Manager (AD) cannot be revoked: leaving the platform with no AD is unrecoverable. ${AD_TRANSFER_HINT}`;
      } else if (resp.code === "SYSTEM_ADMIN_PROTECTED") {
        title = "System Admin protected";
        text = "System Admin accounts require manual disposition.";
      }
      Swal.fire({
        title,
        text,
        icon: resp.code === "NO_ACTIVE_ROLE" ? "info" : "error",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
    }
  };

  const roleColumn = {
    field: "role",
    headerName: "Roles",
    flex: 1,
    minWidth: 260,
    renderCell: (params) => (
      <RoleChips
        row={params.row}
        catalog={roles}
        isAD={isAD}
        onAddRole={handleAddRole}
        onDeactivate={deactivateRole}
        onTransferAd={setAdTransferFrom}
      />
    ),
  };

  // Transferring your own Platform Manager away leaves this session rendering
  // AD-only controls it can no longer use, so say so rather than let the next
  // click fail.
  const handleAdTransferred = async ({ selfTransfer, targetName }) => {
    setAdTransferFrom(null);

    if (selfTransfer) {
      await Swal.fire({
        title: "Platform Manager transferred",
        text: `Platform Manager now belongs to ${targetName}. You are being signed out: this session no longer holds Platform Manager.`,
        icon: "success",
        confirmButtonText: "OK",
        showCloseButton: true,
      });
      // Telling the admin to sign in again was not enough. useRole resolves
      // from Redux first and the stored `admin` payload second, and both still
      // claim AD, so every AD-only control on the page stays live and every
      // one of them now 403s. Clear the same keys the logout path clears
      // (Sidebar.logoutHandler), drop the Redux identity with it, and go.
      localStorage.removeItem("accessToken");
      localStorage.removeItem("admin");
      localStorage.removeItem("navOpen");
      localStorage.removeItem("navOpen3");
      localStorage.removeItem("navOpen5");
      dispatch({ type: ADMIN_LOGOUT });
      navigate("/login");
      return;
    }

    Swal.fire({
      title: "Platform Manager transferred",
      text: `Platform Manager now belongs to ${targetName}.`,
      icon: "success",
      confirmButtonText: "OK",
      showCloseButton: true,
    });
    fetchuserData();
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      minWidth: 180,
      renderCell: (params) => {
        const { corporateverificationStatus, comp_isVerified, id } =
          params?.row || {};
        const showEditIcon = corporateverificationStatus && !comp_isVerified;
        const hasEditPermission = validatePermission(
          "Users Management - Users:Edit",
          permissions,
          permissionsMapping
        );
        const hasDeletePermission = validatePermission(
          "Users Management - Users:Delete",
          permissions,
          permissionsMapping
        );

        return (
          <div className="cellAction">
            <Link to={`/users/${id}`} style={{ textDecoration: "none" }}>
              <div className="viewButton">
                {showEditIcon ? (
                  <EditOutlinedIcon className="custom-edit-icon" />
                ) : (
                  <RemoveRedEyeOutlinedIcon />
                )}
              </div>
            </Link>

            {hasEditPermission && (
              <div
                className="editButton"
                onClick={() => handleOpen(params.row)}
              >
                <EditOutlinedIcon />
              </div>
            )}

            {hasDeletePermission && (
              <div className="deleteButton" onClick={() => deleteFunction(id)}>
                <DeleteOutlineIcon />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const statusColumn = [
    {
      field: "userStatus",
      headerName: "Status",
      flex: 1,
      minWidth: 80,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <span
              className={`status ${
                params.row.userStatus == 1 ? "Approved" : "Pending "
              }`}
            >
              {params.row.userStatus == 1 ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
    },
  ];

  const columnVisibilityModel = useResponsiveColumns(USER_COL_PRIORITY);

  const userColumns = [
    { field: "id", headerName: "ID", width: 70 },
    {
      field: "profilePic",
      headerName: "Profile",
      flex: 1,
      minWidth: 80,
      renderCell: (params) => {
        let progressCircularbar = percentage;
        return (
          <div className="cellWrapper ">
            <div className="profilePic">
              <img
                src={
                  params.row.profilePic == null
                    ? ProfilePic
                    : params?.row?.profilePic
                }
                className="userImage"
              />
              {progressCircularbar
                ?.filter((d) => d?.userid == params.row.id)
                ?.map((percentile) => (
                  <CircularProgressbar
                    key={percentile?.userid}
                    value={percentile?.percentage}
                    className="adminProfile-progress"
                  />
                ))}
            </div>
          </div>
        );
      },
    },
    {
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          params?.row?.firstname?.charAt(0)?.toUpperCase() +
          params?.row?.firstname?.slice(1) +
          " " +
          params?.row?.lastname?.charAt(0)?.toUpperCase() +
          params?.row?.lastname?.slice(1)
        );
      },
    },

    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
    },

    {
      field: "KYC_status",
      headerName: "Individual KYC Status",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        const isVerified = params?.row?.isVerified;

        return <span>{isVerified == true ? "Verified" : "Not Verified"}</span>;
      },
    },
    {
      field: "Comp_KYC_status",
      headerName: "Corporate KYC Status",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => {
        const compIsVerified = params?.row?.comp_isVerified;

        return (
          <span>{compIsVerified == true ? "Verified" : "Not Verified"}</span>
        );
      },
    },
    {
      field: "userType",
      headerName: "Type Of User",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const userType = params?.row?.userType;
        return <span>{userType ? userType : "-"}</span>;
      },
    },
    // {
    //   field: "percent",
    //   headerName: "Progress",
    //   width: 250,
    //   renderCell: (params) => {
    //     let progressBar = percentage;
    //     return progressBar
    //       ?.filter((d) => d?.userid == params.row.id)
    //       ?.map((percentile) => (
    //         <LinearProgressWithLabel
    //           value={percentile?.percentage}
    //           key={percentile?.userid}
    //         />
    //       ));
    //   },
    // },
  ];
  const deleteFunction = (id) => {
    const token = localStorage.getItem("accessToken");
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this user!",
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        var config = {
          method: "patch",
          url: process.env.REACT_APP_API + "delete-user",
          headers: {
            "x-access-token": token,
          },
          data: {
            user_id: id,
            is_deleted: 1,
          },
        };

        axios(config)
          .then(function (response) {
            if (response.status == 200) {
              setLoading(false);
              // setOpen(false);
              Swal.fire({
                title: "User is deleted Successfully",
                timer: 2500,
                timerProgressBar: true,
                icon: "success",
                confirmButtonText: "OK",
                showCloseButton: true,
              });
            }
            fetchuserData();
          })

          .catch(function (error) {
            setLoading(false);
            if (error?.response?.data?.message) {
              Swal.fire({
                title: "Error",
                timer: 2500,
                timerProgressBar: true,
                text: error?.response?.data?.message,
                icon: "error",
                confirmButtonColor: "#f27474",
                confirmButtonText: "OK",
                dangerMode: true,
                showCloseButton: true,
              });
            }
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        setLoading(false);
        Swal.fire("Cancelled", "User is not deleted", "error");
      }
    });
  };

  const updateUserInfo = () => {
    const token = localStorage.getItem("accessToken");
    setLoading(true);
    var config = {
      method: "patch",
      url: process.env.REACT_APP_API + "admin/update-user-detail-byadmin",
      headers: {
        "x-access-token": token,
      },
      data: {
        user_id: id,
        firstname: firstname,
        lastname: lastname,
      },
    };
    axios(config)
      .then(function (response) {
        if (response.data.status == 200) {
          setLoading(false);
          setOpen(false);
          Swal.fire({
            title: "User Information Updated Successfully",
            timer: 2500,
            timerProgressBar: true,
            icon: "success",
            confirmButtonText: "OK",
            showCloseButton: true,
          });
        }
        setOpen(false);
        fetchuserData();

        // setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error?.response?.message) {
          Swal.fire({
            title: "Error",
            timer: 2500,
            timerProgressBar: true,
            text: error?.response?.data?.message,
            icon: "error",
            confirmButtonColor: "#f27474",
            confirmButtonText: "OK",
            dangerMode: true,
            showCloseButton: true,
          });
        }
      });
  };

  return (
    <PageShell><PageHead title="Users" /><div className="datatable">
      <Loader isLoading={loading} />
      <div className="datatableTitle">
        <div className="tablesearch">
          <input type="text" placeholder="Search..." onChange={handleQuery} />
          <SearchOutlinedIcon className="sarchicon" />
        </div>
        <h5 style={{ marginLeft: "-10%" }}>Users</h5>
        <select
          value={verfiecationStatus}
          onChange={(e) => setVerificationStatus(e.target.value)}
          style={{ cursor: "pointer" }}
        >
          <option value="">All</option>
          <option value="individual_verified">Individual Verified</option>
          <option value="individual_non_verified">
            Individual Not Verified
          </option>
          <option value="corporate_verified">Corporate Verified</option>
          <option value="corporate_non_verified">Corporate Not Verified</option>
        </select>
      </div>
      <DataGrid
        className="datagrid"
        autoHeight
        // Rows grow with the Roles cell: one line per held role plus the
        // picker. Without this the grid clips every chip after the first line.
        getRowHeight={(params) => roleRowHeight(params.model, roles, isAD)}
        rows={pageState.data}
        rowCount={pageState.total}
        rowsPerPageOptions={[10, 30, 50, 70, 100]}
        pagination
        page={pageState.page - 1}
        pageSize={pageState.pageSize}
        paginationMode="server"
        onPageChange={(newPage) => {
          setPageState((old) => ({ ...old, page: newPage + 1 }));
        }}
        onPageSizeChange={(newPageSize) =>
          setPageState((old) => ({ ...old, pageSize: newPageSize }))
        }
        columns={userColumns.concat(statusColumn, roleColumn, actionColumn)}
        columnVisibilityModel={columnVisibilityModel}
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-popup">
          <div className="modal-top">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              Update User Information
            </Typography>
            <Button className="closeBtn" onClick={() => setOpen(false)}>
              <img src={Close} alt="close-icon" />
            </Button>
          </div>
          <Typography id="modal-modal-description" sx={{ mt: 1 }}>
            <div className="new">
              <div className="newContainer">
                <div
                  className="bottom"
                  style={{ boxShadow: "none", padding: "0" }}
                >
                  <div className="right">
                    <form className="accredited-investorForm">
                      <div className="formInput" id="commissionInput">
                        <label>Firstname</label>
                        <input
                          type="text"
                          name="firstname"
                          placeholder="Enter FirstName"
                          value={firstname}
                          onChange={updateFirstName}
                        />
                      </div>
                      <div className="formInput" id="commissionInput">
                        <label>Lastname</label>
                        <input
                          type="text"
                          name="lastname"
                          placeholder="Enter LastName"
                          value={lastname}
                          onChange={updateLastName}
                        />
                      </div>

                      <div className="formInput" id="commissionInput">
                        <label>Email</label>
                        <input
                          type="text"
                          name="lastname"
                          placeholder="Enter LastName"
                          value={getEmail}
                          readOnly
                        />
                      </div>

                      <div className="item accreditedItem">
                        <div className="details profile-info">
                          <div className="submitButton">
                            <button
                              className="approveButton"
                              type="button"
                              disabled={!firstname || !lastname}
                              onClick={updateUserInfo}
                            >
                              Update
                            </button>

                            <button
                              className="cancelButton"
                              type="button"
                              onClick={() => setOpen(false)}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </Typography>
        </Box>
      </Modal>

      <AdTransferDialog
        open={!!adTransferFrom}
        fromUser={adTransferFrom}
        callerId={loginUserID}
        onClose={() => setAdTransferFrom(null)}
        onTransferred={handleAdTransferred}
      />

      <Modal
        open={!!sponsorModal}
        onClose={() => setSponsorModal(null)}
        aria-labelledby="sponsor-modal-title"
      >
        <Box className="modal-popup">
          <div className="modal-top">
            <Typography id="sponsor-modal-title" variant="h6" component="h2">
              Select a sponsoring BDC
            </Typography>
            <Button className="closeBtn" onClick={() => setSponsorModal(null)}>
              <img src={Close} alt="close-icon" />
            </Button>
          </div>
          <Typography component="div" sx={{ mt: 1 }}>
            <p style={{ fontSize: 13, color: "#666", margin: "0 0 12px" }}>
              The Consultant role must be sponsored by an active Business
              Development Contractor. Search for the sponsoring BDC below.
            </p>
            <div style={{ display: "flex", gap: 8, marginBottom: 12 }}>
              <input
                type="text"
                placeholder="Search BDC by name or email"
                value={sponsorSearch}
                onChange={(e) => setSponsorSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    searchSponsors();
                  }
                }}
                style={{ flex: 1, padding: "8px 12px", fontSize: 14 }}
              />
              <button type="button" className="approveButton" onClick={searchSponsors}>
                Search
              </button>
            </div>

            <div style={{ maxHeight: 240, overflow: "auto", border: "1px solid #eee", borderRadius: 4 }}>
              {sponsorLoading ? (
                <p style={{ padding: 12, margin: 0, color: "#666" }}>Searching…</p>
              ) : sponsorResults.length === 0 ? (
                <p style={{ padding: 12, margin: 0, color: "#666" }}>
                  No BDC users found. Try a different search term.
                </p>
              ) : (
                sponsorResults.map((u) => (
                  <label
                    key={u.id}
                    style={{
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                      padding: "8px 12px",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                      background: selectedSponsor?.id === u.id ? "#eef4ff" : "transparent",
                    }}
                  >
                    <input
                      type="radio"
                      name="sponsor"
                      checked={selectedSponsor?.id === u.id}
                      onChange={() => setSelectedSponsor(u)}
                    />
                    <span>
                      <strong>
                        {[u.firstname, u.lastname].filter(Boolean).join(" ") || u.email}
                      </strong>
                      <span style={{ color: "#666", marginLeft: 8, fontSize: 12 }}>
                        {u.email} · #{u.id}
                      </span>
                    </span>
                  </label>
                ))
              )}
            </div>

            <div className="formInput" style={{ marginTop: 12 }}>
              <label>Reason (optional)</label>
              <input
                type="text"
                placeholder="Reason for this assignment"
                value={assignReason}
                onChange={(e) => setAssignReason(e.target.value)}
              />
            </div>

            <div className="submitButton" style={{ marginTop: 12 }}>
              <button
                className="approveButton"
                type="button"
                disabled={!selectedSponsor}
                onClick={confirmSponsorAssignment}
              >
                Assign Consultant
              </button>
              <button
                className="cancelButton"
                type="button"
                onClick={() => setSponsorModal(null)}
              >
                Cancel
              </button>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div></PageShell>
  );
};

export default Userlist;
